import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWard = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 512,
	height: 512,
	viewBox: "0 0 512 512",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M20 256L11.3502 250.982L8.439 256L11.3502 261.018L20 256ZM491.904 256L500.554 261.018L503.465 256L500.554 250.982L491.904 256ZM28.6498 261.018C74.1086 182.66 158.886 130 255.952 130V110C151.468 110 60.2399 166.71 11.3502 250.982L28.6498 261.018ZM255.952 130C353.018 130 437.796 182.66 483.255 261.018L500.554 250.982C451.664 166.71 360.437 110 255.952 110V130ZM483.255 250.982C437.796 329.34 353.018 382 255.952 382V402C360.437 402 451.664 345.29 500.554 261.018L483.255 250.982ZM255.952 382C158.886 382 74.1086 329.34 28.6498 250.982L11.3502 261.018C60.2399 345.29 151.468 402 255.952 402V382Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "path-2-inside-1_1_2",
			fill: "white",
			children: /* @__PURE__ */ _jsx("path", { d: "M370.592 244.174C370.592 307.591 319.183 359 255.766 359C192.35 359 140.94 307.591 140.94 244.174C140.94 180.757 192.35 129.348 255.766 129.348C319.183 129.348 370.592 180.757 370.592 244.174Z" })
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M352.592 244.174C352.592 297.649 309.242 341 255.766 341V377C329.124 377 388.592 317.532 388.592 244.174H352.592ZM255.766 341C202.291 341 158.94 297.649 158.94 244.174H122.94C122.94 317.532 182.408 377 255.766 377V341ZM158.94 244.174C158.94 190.698 202.291 147.348 255.766 147.348V111.348C182.408 111.348 122.94 170.816 122.94 244.174H158.94ZM255.766 147.348C309.242 147.348 352.592 190.698 352.592 244.174H388.592C388.592 170.816 329.124 111.348 255.766 111.348V147.348Z",
			fill: "currentColor",
			mask: "url(#path-2-inside-1_1_2)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M255.766 167C213.348 167.126 179 201.552 179 244C179 247.194 179.194 250.342 179.572 253.434H195.725C195.248 250.359 195 247.209 195 244C195 210.389 222.184 183.126 255.766 183V167Z",
			fill: "currentColor"
		})
	]
});
export default SvgWard;
